import type { TransferReplacementsData } from '@lib/api/transfer-replacements';
import type { TransferReplacementCard } from 'types/readiness';

/**
 * Maps the funnels transfer-replacements response into the card array the
 * step and verdict blocks consume. Index 0 is the locked rank-1 teaser (no
 * player, uplift only), followed by the visible cards (the endpoint returns
 * at most two). Selection logic keys off this index order, so it must stay
 * [locked, ...visible].
 */
export const buildReplacementCards = (
  data: TransferReplacementsData
): TransferReplacementCard[] => {
  // The card array must lead with the locked teaser, since selection and the
  // step/verdict blocks key off index 0 being locked. Without a locked pick
  // there is no teaser to anchor the step, so render nothing rather than let a
  // visible card slide into the locked slot.
  if (!data.locked) return [];

  return [
    { player: null, pointsUplift: data.locked.pointsUplift, isLocked: true },
    ...data.visible.map((card) => ({
      player: card.player,
      pointsUplift: card.pointsUplift,
      isLocked: false
    }))
  ];
};
